<script>
import { page } from '$app/state'
import { WebflowNav, WebflowScripts, WebflowStyles } from '$lib/components/webflow'

/**
 * @typedef {Object} Props
 * @property {import('svelte').Snippet} [children]
 */

/** @type {Props} */
let { children } = $props()

const counterUp = $derived(page.url.pathname === '/')
</script>

<WebflowStyles />
<div class="body webflow-site">
  <WebflowNav />
  {@render children?.()}
</div>
<WebflowScripts {counterUp} />

<style>
  :global(.page-byline) {
    margin: 0.35rem 0 0.75rem;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.45);
    letter-spacing: 0.01em;
  }
  :global(.page-byline time) {
    color: rgba(255, 255, 255, 0.6);
  }
</style>
